import React, { type ReactNode, createContext, useContext } from "react"

import {
  type LeadMissingField,
  type LeadMissingFields,
  NO_MISSING_FIELDS
} from "./lead-missing-fields.ts"

const LeadMissingFieldsContext =
  createContext<LeadMissingFields>(NO_MISSING_FIELDS)

interface LeadMissingFieldsProviderProps {
  missing: LeadMissingFields
  children: ReactNode
}

function LeadMissingFieldsProvider({
  missing,
  children
}: LeadMissingFieldsProviderProps) {
  return (
    <LeadMissingFieldsContext.Provider value={missing}>
      {children}
    </LeadMissingFieldsContext.Provider>
  )
}

/** Every card asks by its own id, so no card has to be told it was named. */
function useLeadMissingCardFields(card?: string): LeadMissingField[] {
  const missing = useContext(LeadMissingFieldsContext)
  return card ? missing.forCard(card) : []
}

export { LeadMissingFieldsProvider, useLeadMissingCardFields }
